<div class="team-page">

  <button class="back-btn" (click)="back()">← Tutti gli eventi</button>

  <div class="loading" *ngIf="loading">Caricamento...</div>

  <div class="error-box" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && event">

    <!-- INTESTAZIONE -->
    <div class="event-header">
      <h1 *ngIf="canSee('client')">{{ event.client?.name }} {{ event.client?.lastname }}</h1>
      <h1 *ngIf="!canSee('client')">Evento</h1>
      <span class="event-badge">Sola lettura</span>
    </div>

    <!-- INFO PRINCIPALI -->
    <div class="info-card" *ngIf="canSee('event_data') || canSee('trial')">
      <ng-container *ngIf="canSee('event_data')">
        <div class="info-row" *ngIf="event.event?.date">
          <span class="info-label">Data</span>
          <span class="info-value">{{ formatDate(event.event?.date) }}</span>
        </div>
        <div class="info-row" *ngIf="event.event?.time">
          <span class="info-label">Ora</span>
          <span class="info-value">{{ event.event?.time }}</span>
        </div>
        <div class="info-row" *ngIf="event.event?.location">
          <span class="info-label">Location</span>
          <span class="info-value">{{ event.event?.location }}</span>
        </div>
      </ng-container>
      <div class="info-row" *ngIf="canSee('trial') && event.event?.test_date">
        <span class="info-label">Sopralluogo</span>
        <span class="info-value">
          {{ formatDate(event.event?.test_date) }}
          <ng-container *ngIf="event.event?.test_time"> — ore {{ event.event?.test_time }}</ng-container>
          <ng-container *ngIf="event.event?.test_location"> · {{ event.event?.test_location }}</ng-container>
        </span>
      </div>
    </div>

    <!-- FOTO -->
    <div class="section" *ngIf="canSee('photos') && gallery.length > 0">
      <h2 class="section-title">Foto</h2>
      <div class="photo-grid">
        <img
          *ngFor="let img of gallery"
          [src]="getImageUrl(img.key)"
          class="photo-thumb"
          loading="lazy"
        />
      </div>
    </div>

    <!-- SERVIZI -->
    <div class="section" *ngIf="canSee('services') && selectedServices.length > 0">
      <h2 class="section-title">Servizi</h2>
      <div class="line-list">
        <div class="line-row" *ngFor="let s of selectedServices">
          <span class="line-name">
            {{ s.name }}
            <span class="line-qty" *ngIf="(s.quantity ?? 1) > 1">×{{ s.quantity }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- TEAM ASSEGNATO -->
    <div class="section" *ngIf="teamPeople.length > 0">
      <h2 class="section-title">Team assegnato</h2>
      <div class="team-list">
        <div class="team-row" *ngFor="let p of teamPeople" [class.me]="isMe(p)">
          <div class="team-avatar">{{ (p.name || '?')[0] }}</div>
          <div class="team-info">
            <span class="team-name">{{ p.name }} {{ p.lastname }}</span>
            <span class="team-role" *ngIf="p.role">{{ p.role }}</span>
          </div>
          <span class="me-badge" *ngIf="isMe(p)">Tu</span>
        </div>
      </div>
    </div>

    <!-- PARTECIPANTI -->
    <div class="section" *ngIf="canSee('participants') && partecipanti.length > 0">
      <h2 class="section-title">Partecipanti</h2>
      <div class="team-list">
        <div class="team-row" *ngFor="let p of partecipanti">
          <div class="team-avatar">{{ (p.name || '?')[0] }}</div>
          <div class="team-info">
            <span class="team-name">{{ p.name || '—' }}</span>
            <span class="team-role" *ngIf="p.role">{{ p.role }}</span>
          </div>
          <div class="partecipante-tags">
            <span *ngIf="p.hair"><app-icon name="scissors" [size]="13" /></span>
            <span *ngIf="p.makeup"><app-icon name="sparkle" [size]="13" /></span>
          </div>
        </div>
      </div>
    </div>

    <!-- NOTE -->
    <div class="section" *ngIf="canSee('trial') && event.event?.note?.text">
      <h2 class="section-title">Note</h2>
      <p class="note-text">{{ event.event?.note?.text }}</p>
    </div>

  </ng-container>

</div>
